import { Routes } from '@angular/router';
import { AdminRoutes } from './views/admin/admin-routing.module';
import { IsVerifiedAccountStateGuard } from './core/guards/is-verified-account-state.guard';
import { AccountActivationComponent } from './views/admin/pages/auth/account-activation/account-activation.component';
import { ForgetPasswordComponent } from './views/admin/pages/auth/forget-password/forget-password.component';
import { LoginComponent } from './views/admin/pages/auth/login/login.component';
import { RecoveryPasswordComponent } from './views/admin/pages/auth/recovery-password/recovery-password.component';

export const routes: Routes = [
    {path: '', redirectTo: '/login',pathMatch:'full'},
     AdminRoutes,
     
  {
    path:"activate-account",
    component:AccountActivationComponent,
    canActivate:[IsVerifiedAccountStateGuard]
  },
  {
    path:"login",
    component:LoginComponent,
  //  canActivate:[IsAuthedGuard]
  },
 
  {
    path:"forget-password",
    component:ForgetPasswordComponent
  },
  {
    path:"recovery-password/:token",
    component:RecoveryPasswordComponent
  },
];
